"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getResults = getResults;
exports.questions = void 0;

var _sum2 = _interopRequireDefault(require("lodash/sum"));

var _utils = require("./utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var batteryId = _utils.screeners.RTW_PRE_SCREENER;
var baseProps = {
  batteryId: batteryId,
  aggregated: true,
  type: "multi",
  extraText: "Please answer this pre-screening questionnaire to proceed",
  inline: false
};
var rtwPreScreenerQuestions = [{
  prompt: "Are you under 18 years old?",
  type: "radio",
  options: ["Yes", "No"],
  key: "underAge",
  eval: function _eval(n, q) {
    return q.options[n];
  }
}, {
  prompt: "Are you engaged in any legal action with your Employer?",
  type: "radio",
  options: ["Yes", "No"],
  key: "engagedInLegalAction",
  eval: function _eval(n, q) {
    return q.options[n];
  }
}, {
  prompt: "Is it difficult for you to understand videos in English or talk in English?",
  type: "radio",
  options: ["Yes", "No"],
  key: "understandEnglish",
  eval: function _eval(n, q) {
    return q.options[n];
  }
}, {
  prompt: "Are you feeling suicidal or planning to harm yourself or someone else?",
  type: "radio",
  options: ["Yes", "No"],
  key: "feelingSuicidal",
  eval: function _eval(n, q) {
    return q.options[n];
  }
}, {
  prompt: "Has your claim (or sick leave) been ongoing for between two to 26 weeks?",
  type: "radio",
  options: ["Yes", "No"],
  key: "sickLeave",
  eval: function _eval(n, q) {
    return q.options[n];
  }
}, {
  prompt: "Do you live in Australia?",
  type: "radio",
  options: ["Yes", "No"],
  key: "inAustralia",
  eval: function _eval(n, q) {
    return q.options[n];
  }
}];
var questions = (0, _utils.wrapBattery)(rtwPreScreenerQuestions, baseProps);
exports.questions = questions;

function getResults(answers) {
  var score = Math.round((0, _sum2["default"])(answers));
  return {
    RTW_PRE_SCREENER: score,
    RTW_PRE_SCREENER_1: answers[0],
    RTW_PRE_SCREENER_2: answers[1],
    RTW_PRE_SCREENER_3: answers[2],
    RTW_PRE_SCREENER_4: answers[3],
    RTW_PRE_SCREENER_5: answers[4]
  };
}